import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import DashboardLayout from "../../../components/ui/DashboardLayout";
import { LoaderIcon } from "../../../components/ui/Swicons";
import {
  devURL,
  rateLimiter,
  removeInitialsFromName,
  titleCase,
} from "../../../utils";

export default function AddRecipient() {
  const token = localStorage.getItem("swToken");
  const { register, handleSubmit } = useForm();
  const [loader, isLoading] = useState(false);
  const navigate = useNavigate();
  const [isDisabledLogin, setDisabledLogin] = useState(true);
  const [recipients, setRecipients] = useState([]);
  const initialValues = {
    recipient_name: "",
    recipient_nick_name: "",
    bank_account_number: "",
    ifsc_code: "",
    country: "",
    bank_name: "",
  };
  useEffect(() => {
    getAllRecipientsData();
  }, []);

  const [formValues, setFormValues] = useState(initialValues);

  const getAllRecipientsData = () => {
    axios
      .get(`${devURL}/recipient/all`, {
        headers: { token: token },
      })
      .then((res) => {
        setRecipients(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error("Session expired please login again");
          localStorage.removeItem("swToken");
          navigate("/Login");
        }
        console.log(err);
      });
  };
  function stripZeroes(str) {
    return str.replace(/^0+/, "");
  }
  const handleChange = (e) => {
    if (e.target.name === "recipient_name" && e.target.value.length >= 0) {
      formValues.recipient_name = titleCase(e.target.value);
    } else if (
      e.target.name === "recipient_nick_name" &&
      e.target.value.length >= 0
    ) {
      formValues.recipient_nick_name = e.target.value;
    } else if (
      e.target.name === "bank_account_number" &&
      e.target.value.length >= 0
    ) {
      formValues.bank_account_number = e.target.value;
      if (/[a-zA-Z]/.test(e.target.value)) {
        toast.error("Please enter valid bank account number.");
        return;
      }
    } else if (e.target.name === "ifsc_code" && e.target.value.length >= 0) {
      formValues.ifsc_code = e.target.value;
    } else if (e.target.name === "country" && e.target.value.length >= 0) {
      formValues.country = e.target.value;
    } else {
      setDisabledLogin(true);
    }
    if (
      formValues.recipient_name !== "" &&
      formValues.recipient_nick_name !== "" &&
      formValues.bank_account_number !== "" &&
      formValues.ifsc_code !== "" &&
      formValues.country !== ""
    ) {
      setDisabledLogin(false);
    } else {
      setDisabledLogin(true);
    }
    //console.log(formValues);
  };
  const onSubmit = (val) => {
    // duration: in ms , label, rate
    if (rateLimiter(30 * 60 * 100, "account_verify", 5) === false) {
      toast.error("Too many requests, Try again after some time");
      return;
    }
    var ifsc_code = [];
    if (val.recipient_name === "") {
      toast.error("Please enter recipient name.");
      isLoading(false);
    } else if (val.recipient_nick_name === "") {
      toast.error("Please enter recipient nick name.");
      isLoading(false);
    } else if (val.bank_account_number === "") {
      toast.error("Please enter bank account number.");
      isLoading(false);
    } else if (val.ifsc_code === "") {
      toast.error("Please enter ifsc code.");
      isLoading(false);
    } else if (val.country === "") {
      toast.error("Please enter country.");
      isLoading(false);
    } else if (
      recipients.some(
        (recipient) =>
          recipient.bank_account_number ===
          stripZeroes(formValues.bank_account_number)
      )
    ) {
      toast.error("Recipient with same bank account number already exists.");
      isLoading(false);
    } else {
      if (val.ifsc_code !== "" && val.bank_account_number !== "") {
        let body = {
          ifsc_code: val.ifsc_code,
          account_number: val.bank_account_number,
        };
        isLoading(true);
        axios
          .post(`${devURL}/misc/verify-account-number`, body, {
            headers: { token: token },
          })
          .then((res) => {
            if (res.data.account_exists) {
              isLoading(true);
              Swal.fire({
                title: "Confirm recipient details",
                html:
                  '<div class="text-left text-slate-600">' +
                  "<b>NAME :</b> " +
                  titleCase(removeInitialsFromName(res.data.full_name)) +
                  "<br />" +
                  "<b>BANK :</b> " +
                  res.data.ifsc_details.bank +
                  "<br />" +
                  "<b>BRANCH :</b> " +
                  res.data.ifsc_details.branch +
                  " <br />" +
                  "<b>CITY :</b> " +
                  res.data.ifsc_details.city +
                  " <br />" +
                  "<b>STATE :</b> " +
                  res.data.ifsc_details.state +
                  " <br />" +
                  "<b>IFSC :</b> " +
                  res.data.ifsc_details.ifsc +
                  " <br />" +
                  "</div>",
                dangerMode: true,
                showCancelButton: true,
                confirmButtonText: "Confirm",
                confirmButtonColor: "#2878bb",
                cancelButtonColor: "#EA0000",
              }).then((result) => {
                if (result.isDenied) {
                  isLoading(false);
                }
                if (result.isConfirmed) {
                  axios
                    .post(
                      `${devURL}/recipient/add`,
                      {
                        recipient_name: titleCase(
                          removeInitialsFromName(res.data.full_name)
                        ),
                        recipient_nick_name: val.recipient_nick_name,
                        bank_account_number: val.bank_account_number,
                        ifsc_code: val.ifsc_code,
                        country: val.country,
                        bank_name: res.data.ifsc_details.bank,
                      },
                      {
                        headers: { token: token },
                      }
                    )
                    .then((res) => {
                      isLoading(false);
                      toast.success("Recipient added successfully!");
                      navigate("/Recipient-List");
                    })
                    .catch((err) => {
                      isLoading(false);
                      if (err.response.status === 401) {
                        localStorage.removeItem("swToken");
                        toast.error("Session expired please login again");
                        return navigate("/Login");
                      }
                      if (
                        err.response &&
                        err.response.data &&
                        err.response.data.errorMessage
                      ) {
                        toast.error(err.response.data.errorMessage);
                      }
                    });
                } else {
                  isLoading(false);
                }
              });
            } else {
              toast.error("Please enter ifsc code.");
              isLoading(false);
            }
          })
          .catch((err) => {
            if (err.name === "AxiosError") {
              if (err.response.data.account_exist === false) {
                toast.error(
                  "Bank account not found please provide correct bank credentials"
                );
              }
            }
            isLoading(false);
          });
      }
    }
  };
  return (
    <DashboardLayout>
      <div className="page-title text-xl font-bold">
        <p>Add Recipient</p>
      </div>
      <div className="sw-add-recipient-form mt-6">
        <form onSubmit={handleSubmit(onSubmit)} className="lg:w-1/2">
          <div className="mb-6">
            <label
              htmlFor="recipient_name"
              className="text-gray-600 text-sm text-left font-bold mb-1"
            >
              Recipient Name<span style={{ color: "red" }}>*</span>
            </label>
            <input
              {...register("recipient_name")}
              onChange={handleChange}
              name="recipient_name"
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Enter recipient name"
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="recipient_nick_name"
              className="text-gray-600 text-sm text-left font-bold mb-1"
            >
              Recipient Nick Name<span style={{ color: "red" }}>*</span>
            </label>
            <input
              {...register("recipient_nick_name")}
              onChange={handleChange}
              name="recipient_nick_name"
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Enter recipient nick name"
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="bank_account_number"
              className="text-gray-600 text-sm text-left font-bold mb-1"
            >
              Bank Account Number<span style={{ color: "red" }}>*</span>
            </label>
            <input
              {...register("bank_account_number")}
              onChange={handleChange}
              name="bank_account_number"
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Enter bank account number"
              type="text"
            />
            <p className="text-sm italic opacity-80 pt-1">
              NRE accounts are not currently supported.
            </p>
          </div>
          <div className="mb-6">
            <label
              htmlFor="ifsc_code"
              className="text-gray-600 text-sm text-left font-bold mb-1"
            >
              IFSC Code<span style={{ color: "red" }}>*</span>
            </label>
            <input
              {...register("ifsc_code")}
              onChange={handleChange}
              name="ifsc_code"
              className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
              placeholder="Enter IFSC code"
            />
          </div>
          <div className="mb-6">
            <label
              htmlFor="country"
              className="text-gray-600 text-sm text-left font-bold mb-1"
            >
              Country<span style={{ color: "red" }}>*</span>
            </label>
            <select
              {...register("country")}
              onChange={handleChange}
              name="country"
              className="appearance-none relative block w-full px-3 py-2 mb-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10"
              placeholder="Enter country"
            >
              <option value="">Select Country</option>
              <option value="India">India</option>
            </select>
          </div>
          <div className="mb-6">
            <button
              type="submit"
              className="group relative py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-themeColor hover:bg-themeHover"
              // style={{ backgroundColor: "#5C6E64" }}
              style={
                !isDisabledLogin
                  ? { backgroundColor: "#246eaa" }
                  : { backgroundColor: "#246eaa", opacity: "50%" }
              }
              disabled={isDisabledLogin}
            >
              {loader && <LoaderIcon />}
              {!loader && <>Submit</>}
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
}
